<template>
  <el-container class="container" v-bind:style="containerStyle">
    <el-header class="menu-toggle" height="30">
      <div class="item" v-show="!isCollapse">
        <i class="title">快速查询</i>
      </div>
      <div class="item" style="text-align: right;cursor: pointer">
        <i class="el-icon-menu" v-show="!isCollapse" title="收起" @click.prevent="doCollapse"></i>
        <i class="el-icon-menu" v-show="isCollapse" title="展开" @click.prevent="doCollapse"></i>
      </div>
    </el-header>
    <el-main class="main" v-show="!isCollapse">
      <el-scrollbar ref="scrollbar" viewStyle="padding: 0px 10px;" style="height: 100%;">
        <el-menu class="no-boarder" @select="onSelectQuickSearchItem" :default-active="defaultActiveQuickSearchItemIndex">
          <template v-for="(item, index) in quickSearchItems">
            <el-menu-item :index="''+index" class="menu-item">
              <i class="iconfont icon-xianhao"></i>
              <span slot="title">{{item.text}}</span>
            </el-menu-item>
          </template>
        </el-menu>
        <div class="item-title">
          常规查询
        </div>
        <el-form ref="form" :model="searchForm" label-width="80px" size="mini">
          <el-form-item label-width="0" style="text-align: right;">
            <el-radio-group v-model="searchForm.specimenSource" @change="onSpecimenSourceChange" size="mini">
              <template v-for="(item, index) in specimenSourceList">
                <el-radio-button :label="''+item.id">{{item.text}}</el-radio-button>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker type="datetime" placeholder="选择开始日期" v-model="searchForm.startDate"
                            align="right"
                            format="yyyy-MM-dd HH:mm"
                            :clearable="false"
                            :editable="false"
                            style="width: 100%;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker type="datetime" placeholder="选择结束日期" v-model="searchForm.endDate"
                            align="right"
                            format="yyyy-MM-dd HH:mm"
                            :clearable="false"
                            :editable="false"
                            style="width: 100%;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="时间类型">
            <el-select v-model="searchForm.checkTime" @change="checkTimeChange" placeholder="请选择时间类型"
                       style="width: 100%">
              <el-option v-for="item in checkTimeList" :key="item.value" :label="item.text"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="searchForm.userName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="条码">
            <el-input v-model="searchForm.barcode" placeholder="请输入条码"></el-input>
          </el-form-item>
          <el-form-item label="床号">
            <el-input v-model="searchForm.bedID" placeholder="请输入床号"></el-input>
          </el-form-item>
          <el-form-item label="项目名称">
            <el-input v-model="searchForm.project" placeholder="请输入项目名称"></el-input>
          </el-form-item>
          <el-form-item label="就诊类型">
            <el-select v-model="searchForm.treatmentType" @change="treatmentTypeChange" placeholder="请选择就诊类型"
                       style="width: 100%">
              <el-option label="" value=""></el-option>
              <el-option
                v-for="item in treatmentTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="受检者Id">
            <el-input v-model="searchForm.userID" placeholder="请输入受检者Id"></el-input>
          </el-form-item>
          <el-form-item label="申请医生">
            <el-select v-model="searchForm.dc" filterable placeholder="请选择输入申请医生" style="width: 100%">
              <el-option label="" value=""></el-option>
              <el-option
                v-for="item in doctorList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请科室">
            <el-select v-model="searchForm.office" filterable placeholder="请选择输入申请科室" style="width: 100%">
              <el-option label="" value=""></el-option>
              <el-option
                v-for="item in deptList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="样本状态">
            <el-select v-model="searchForm.resultStatus" @change="resultStatusChange" placeholder="请选择结果状态"
                       style="width: 100%">
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in specimenStatusList"
                :key="item.id"
                :label="item.text"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="打印状态">
            <el-select v-model="searchForm.printType" @change="printTypeChange" placeholder="请选择打印状态"
                       style="width: 100%">
              <el-option label="全部" value="0"></el-option>
              <el-option label="已打印" value="1"></el-option>
              <el-option label="未打印" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="纸张类型">
            <el-select v-model="searchForm.paperType" @change="paperTypeChange" placeholder="请选择纸张类型"
                       style="width: 100%">
              <el-option label="全部" value="3"></el-option>
              <el-option
                v-for="item in paperSizeList"
                :key="item.id"
                :label="item.text"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-scrollbar>
    </el-main>
    <el-footer class="footer" v-show="!isCollapse" height="45px">
      <el-button type="primary" size="mini" plain icon="el-icon-search" @click="onSearch"
                 v-loading.fullscreen="isLoading">查询
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import {formatDate} from '@/libs/common';
  import {keyCodes,dictionaryDatas} from "../commons";

  export default {
    data() {
      return {
        containerPadding: 2,
        searchForm: {
          specimenSource: keyCodes.TEST_REPORT_CODE,//自检报告/外检报告
          checkTime: '0',//时间类型
          startDate: '',//开始时间
          endDate: '',//结束时间
          barcode: '',//条码
          userName: '',//姓名
          treatmentType: '',//就诊类型
          userID: '',//受检者id
          dc: '', //申请医生
          office: '',//申请科室
          bedID: '',//床号
          resultStatus: '',//结果状态
          printType: '0',
          project: '',//项目名称
          paperType: '3'//纸张类型
        },
        quickSearchItems: dictionaryDatas.quickSearchItems,
        defaultActiveQuickSearchItemIndex: '0',//默认选中的 最近?天检查情况
        checkTimeList: [],//时间类型列表
        deptList: [],
        doctorList: [],//审请医生
        treatmentTypeList: [], //就诊类型列表
        specimenStatusList: dictionaryDatas.specStatusList,
        paperSizeList: dictionaryDatas.paperSizeList,
        specimenSourceList: dictionaryDatas.specimenSourceList,
      }
    },
    props: {
      myHeight: {
        type: Number
      },
      //是否展开
      isCollapse: {
        type: Boolean
      }
    },
    computed: {
      containerStyle: function () {
        return {
          height: this.myHeight + 'px',
          maxHeight: this.myHeight + 'px'
        }
      },
      ...mapGetters(['isLoading']),
    },
    components: {},
    methods: {
      onSpecimenSourceChange(selectedVal) {
        const _this = this;
        if (selectedVal == keyCodes.TEST_REPORT_CODE) {
          //选择自检报告
          _this.checkTimeList = [
            {text: '按检验时间', value: '0'},
            {text: '按申请时间', value: '1'}
          ];
          _this.searchForm.checkTime = '0';
        } else if (selectedVal == keyCodes.TEST_REPORT_CODE_OUT){
          //选择外检报告
          _this.checkTimeList = [
            {text: '按送检时间', value: '2'}
          ];
          _this.searchForm.checkTime = '2';
        }
      },

      handleOpen(key, keyPath) {
        //console.log(key, keyPath);
        //this.axios
      },
      handleClose(key, keyPath) {
        //console.log(key, keyPath);
      },
      //折叠导航栏
      doCollapse: function () {
        this.$emit('doCollapse', !this.isCollapse);
      },
      /**
       * 点击查询
       */
      onSearch() {
        const _this = this;
        if (!_this.searchForm.startDate) {
          this.$message({
            message: '请选择开始时间',
            type: 'warning'
          });
          return;
        }
        if (!_this.searchForm.endDate) {
          _this.$message({
            message: '请选择结束时间',
            type: 'warning'
          });
          return;
        }
        if (_this.searchForm.startDate > _this.searchForm.endDate) {
          this.$message({
            message: '开始时间 不能晚于 结束时间',
            type: 'warning'
          });
          return;
        }
        let searchParams = $.extend({}, _this.searchForm);
        searchParams.startDate = formatDate(searchParams.startDate, 'yyyy-MM-dd hh:mm:ss');
        searchParams.endDate = formatDate(searchParams.endDate, 'yyyy-MM-dd hh:mm:ss');
        searchParams.usersInDepartment = _this.$store.state.userInfo.id;//当前用户id

        let params = {
          searchParams: searchParams,
          userJson: {orgId: _this.$store.state.userInfo.org_id}
        }
        //转为后端接收到值
        switch (_this.searchForm.specimenSource){
          case keyCodes.TEST_REPORT_CODE_OUT:
            params.searchParams.specimenSource = '1';// 外检报告
            break;
          default:
            params.searchParams.specimenSource = '0';// 默认是 自检报告
            break;
        }

        _this.$emit('onSearch', params);
      },
      /**
       * 当选择 快速查询 菜单时
       */
      onSelectQuickSearchItem(index, keyPath) {
        const vm = this;
        try {
          vm.handleSelectedQuickSearchItem(index);
          vm.onSearch();
        } catch (error) {
          vm.$alert(error.message, '错误');
        }
      },
      /**
       * 处理选中的 快速查询 项
       * @param index 选中的下标
       */
      handleSelectedQuickSearchItem(index) {
        const vm = this;
        let selectedItem = vm.quickSearchItems[index];

        let dateFrom =  new Date(new Date(new Date().toLocaleDateString()).getTime());
        let dateTo = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
        dateFrom = dateFrom - (selectedItem.value - 1) * 24 * 60 * 60 * 1000;

        vm.searchForm.startDate = new Date(dateFrom);//开始时间
        vm.searchForm.endDate = dateTo;//new Date();//结束时间
      },
      /**
       * 选择 就诊类型
       * @param val
       */
      treatmentTypeChange(val) {
        const vm = this;
        try {
          vm.searchForm.treatmentType = val;
        } catch (error) {
          vm.$alert(error.message, '错误');
        }
      },
      /**
       * 选择 结果状态
       * @param val
       */
      resultStatusChange(val) {
        const vm = this;
        try {
          vm.searchForm.resultStatus = val;
        } catch (error) {
          vm.$alert(error.message, '错误');
        }
      },
      /**
       * 选择 打印状态
       * @param val
       */
      printTypeChange(val) {
        const vm = this;
        try {
          vm.searchForm.printType = val;
        } catch (error) {
          vm.$alert(error.message, '错误');
        }
      },
      //选择纸张类型
      paperTypeChange(val) {
        const vm = this;
        try {
          vm.searchForm.paperType = val;
        } catch (error) {
          vm.$alert(error.message, '错误');
        }
      },
      //先择时间类型
      checkTimeChange(val) {
        const vm = this;
        try {
          vm.searchForm.checkTime = val;
        } catch (error) {
          vm.$alert(error.message, '错误');
        }
      },
      initData() {
        const _this = this;
        //处理系统参数配置
        if(_this.$store.state.userSetting){
          _this.$store.state.userSetting.forEach(item => {
            switch (item.setting_code) {
              case keyCodes.QUICK_SEARCH_SETTING_CODE:
                //定位快速查询 项
                for(let index = 0; index< _this.quickSearchItems.length; index++){
                  if(item.setting_value == _this.quickSearchItems[index].id){
                    _this.defaultActiveQuickSearchItemIndex = index + "";
                    break;
                  }
                }
                break;
              case keyCodes.SPEC_SOURCE_SETTING_CODE:
                _this.searchForm.specimenSource = item.setting_value;
                break;
            }
          });
        }
        //时间类型
        _this.onSpecimenSourceChange(_this.searchForm.specimenSource);
        //加载就诊类型
        _this.$store.dispatch('loading');
        _this.apiSystem.getTreatmentTypes(_this.$store.state.userInfo.org_id,
          (treatmentTypes) => {
            _this.treatmentTypeList = treatmentTypes;
            _this.$store.dispatch('loaded');
          },
          _this.onFail
        );
        //加载审请医生
        _this.$store.dispatch('loading');
        _this.apiSystem.getDoctors(_this.$store.state.userInfo.org_id,
          (doctors) => {
            _this.doctorList = doctors;
            _this.$store.dispatch('loaded');
          },
          _this.onFail
        );
        //加载审请科室
        _this.$store.dispatch('loading');
        _this.apiSystem.getDepartments(_this.$store.state.userInfo.org_id, _this.$store.state.userInfo.id,
          (departments) => {
            _this.deptList = departments.filter(function (item) {
              return item.selected == 1;
            });
            if(_this.deptList == null || _this.deptList.length == 0){
              _this.deptList = departments;
            }
            _this.$store.dispatch('loaded');
          },
          _this.onFail
        );
      },
      //失败处理方法
      onFail(error) {
        const _this = this;

        _this.$notify({
          title: '错误',
          message: error.message,
          type: 'error',
          position: 'bottom-right'
        });
        _this.$store.dispatch('loaded');
      },
      onresize() {
        const _this = this;
        setTimeout(function () {
          _this.$refs.scrollbar.update();
        }, 300);
      },
    },
    watch: {},
    mounted() {
      const _this = this;

      _this.initData();
      //处理 快速查询 项
      if(!_this.defaultActiveQuickSearchItemIndex ||
        parseInt(_this.defaultActiveQuickSearchItemIndex) < 0 ||
        parseInt(_this.defaultActiveQuickSearchItemIndex) > _this.quickSearchItems.length - 1) {

        _this.defaultActiveQuickSearchItemIndex = "0";//默认选中 最近1天
      }
      _this.handleSelectedQuickSearchItem(_this.defaultActiveQuickSearchItemIndex);
      //处理 自检、外送
      if(!_this.defaultActiveQuickSearchItemIndex){
        _this.defaultActiveQuickSearchItemIndex = keyCodes.TEST_REPORT_CODE;
      }
    }
  }
</script>

<style scoped lang="scss">
  .container {
    border-right: solid 4px #17a2b8;
    padding-right: 1px;
  }

  .menu-toggle {
    text-align: left;
    height: 30px;
    line-height: 30px;
    padding: 1px;
  }

  .menu-toggle .item {
    float: left;
    width: 50%;
  }

  .menu-toggle .item .iconfont:hover {
    cursor: pointer;
  }

  .quick-search .el-row {
    height: 30px;
    line-height: 30px
  }

  .main {
    padding: 2px;
  }

  .main .menu-item {
    height: 30px;
    line-height: 30px;
  }

  .el-form .el-form-item {
    margin-bottom: 2px
  }

  .no-boarder {
    border: solid 0px
  }

  .footer {
    text-align: right;
    line-height: 45px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ReportSideBar.vue